import { ArrowLeft } from 'lucide-preact'
import { useState } from 'preact/hooks'
import { text } from '#contract'
import { useScreenStack } from '../../app/screen-stack.ts'
import { Button } from '../../components/button.tsx'
import { ScreenPanel } from '../../components/screen-panel.tsx'
import { Tabs } from '../../components/tabs.tsx'
import { useT } from '../../i18n/index.ts'
import { AccessibilityTab } from './accessibility-tab.tsx'
import { AudioTab } from './audio-tab.tsx'
import { ControlsTab } from './controls-tab.tsx'
import { DeveloperTab } from './developer-tab.tsx'
import { GraphicsTab } from './graphics-tab.tsx'
import styles from './settings-screen.module.css'

const TABS = ['graphics', 'audio', 'controls', 'accessibility', 'developer'] as const

type SettingsTab = (typeof TABS)[number]

/** Player settings, opened over the main menu or the pause screen. Changes apply live. */
export function SettingsScreen() {
  const t = useT()
  const { back } = useScreenStack()
  const [tab, setTab] = useState<SettingsTab>('graphics')

  return (
    <ScreenPanel
      title={t(text('settings.title'))}
      footer={
        <Button variant="ghost" icon={ArrowLeft} sound="back" onClick={back}>
          {t(text('settings.back'))}
        </Button>
      }
    >
      <div class={styles.tabs}>
        <Tabs
          autoFocus
          value={tab}
          onChange={setTab}
          tabs={TABS.map((id) => ({ id, label: t(text(`settings.tabs.${id}`)) }))}
        />
      </div>
      {tab === 'graphics' && <GraphicsTab />}
      {tab === 'audio' && <AudioTab />}
      {tab === 'controls' && <ControlsTab />}
      {tab === 'accessibility' && <AccessibilityTab />}
      {tab === 'developer' && <DeveloperTab />}
    </ScreenPanel>
  )
}
